export class ClearPriceBasketInfo {
  products: Array<any> = [];
  name: string = '';
  address: string = '';
  zipCode: string = '';
  city: string = '';
  orderNumber: string = '';
}

export class OrderHistory {
  id: number;
  wholesalerId: number;
  orderDate: string;
  totalAmount: number;
  deliveryAddress: string;
  productCount: number;
  userName: string;
}

export class OrderHistoryLines {
  number: string;
  description: string;
  quantity: number;
  totalAmount: number;
}